module.exports = __webpack_public_path__ + "img/ModularWallV1.0f9d1214.jpg";